var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPleasantlyUseful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 170,
    viewBox: "0 0 255 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_633)",
    filter: "url(#filter0_i_245_633)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9531 93.1959C39.9531 80.2184 50.4713 69.7002 63.4488 69.7002C76.4263 69.7002 86.9445 80.2184 86.9445 93.1959H39.9531ZM86.9445 93.1959C86.9445 106.173 76.4263 116.692 63.4488 116.692C50.4713 116.692 39.9531 106.173 39.9531 93.1959",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5063 99.5084C71.5063 99.5084 68.4806 102.314 63.4406 102.314C58.3984 102.314 55.375 99.5084 55.375 99.5084M55.5498 86.5332V91.4428V86.5332ZM71.3309 86.5332V91.4428V86.5332Z",
    stroke: "white",
    strokeWidth: 4.07445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.297 117.279C168.297 104.301 178.815 93.7832 191.793 93.7832C204.77 93.7832 215.288 104.301 215.288 117.279H168.297ZM215.288 117.279C215.288 130.256 204.77 140.775 191.793 140.775C178.815 140.775 168.297 130.256 168.297 117.279",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.866 123.591C199.866 123.591 196.84 126.397 191.8 126.397C186.758 126.397 183.734 123.591 183.734 123.591M183.909 110.616V115.526V110.616ZM199.69 110.616V115.526V110.616Z",
    stroke: "white",
    strokeWidth: 4.07445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.711 46.1617C152.711 33.1842 163.229 22.666 176.207 22.666C189.184 22.666 199.702 33.1842 199.702 46.1617H152.711ZM199.702 46.1617C199.702 59.1392 189.184 69.6574 176.207 69.6574C163.229 69.6574 152.711 59.1392 152.711 46.1617",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28 52.4743C184.28 52.4743 181.254 55.2796 176.214 55.2796C171.172 55.2796 168.148 52.4743 168.148 52.4743M168.323 39.499V44.4086V39.499ZM184.104 39.499V44.4086V39.499Z",
    stroke: "white",
    strokeWidth: 4.07445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8414 100.89V107.043L85.2812 113.663H108.636C115.695 113.663 121.422 107.943 121.422 100.89C121.422 93.8377 115.695 88.1172 108.636 88.1172H103.627C96.563 88.1172 90.8414 93.8377 90.8414 100.89Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.831 94.7578C112.607 94.7578 114.468 97.3441 114.468 99.7527C114.468 104.642 106.742 108.645 106.601 108.645C106.46 108.645 98.7344 104.642 98.7344 99.7527C98.7344 97.3441 100.595 94.7578 103.37 94.7578C104.957 94.7578 105.999 95.5432 106.601 96.2428C107.203 95.5432 108.245 94.7578 109.831 94.7578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.01 134.041V140.193L171.57 146.813H148.215C141.156 146.813 135.43 141.093 135.43 134.041C135.43 126.988 141.156 121.268 148.215 121.268H153.224C160.288 121.268 166.01 126.988 166.01 134.041Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.151 128.178C144.484 128.178 142.695 130.663 142.695 132.978C142.695 137.676 150.12 141.523 150.255 141.523C150.39 141.523 157.815 137.676 157.815 132.978C157.815 130.663 156.027 128.178 153.36 128.178C151.835 128.178 150.834 128.933 150.255 129.605C149.677 128.933 148.675 128.178 147.151 128.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.877 61.7896V67.9424L153.437 74.5625H130.082C123.023 74.5625 117.297 68.842 117.297 61.7896C117.297 54.7371 123.023 49.0166 130.082 49.0166H135.092C142.155 49.0166 147.877 54.7371 147.877 61.7896Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.904 55.6787C126.137 55.6787 124.281 58.2573 124.281 60.6586C124.281 65.533 131.984 69.5241 132.124 69.5241C132.265 69.5241 139.968 65.533 139.968 60.6586C139.968 58.2573 138.112 55.6787 135.345 55.6787C133.764 55.6787 132.725 56.4618 132.124 57.1594C131.524 56.4618 130.485 55.6787 128.904 55.6787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2352 121.711C86.1083 121.267 88.0897 122.856 88.0897 122.856C88.0897 122.856 87.0323 125.163 85.1586 125.606C83.2855 126.049 81.3047 124.462 81.3047 124.462C81.3047 124.462 82.3621 122.155 84.2352 121.711Z",
    fill: "url(#paint0_linear_245_633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4075 70.4559C92.1647 68.2223 87.2109 69.7835 87.2109 69.7835C87.2109 69.7835 87.5175 74.9654 90.7625 77.1969C94.005 79.4304 98.9568 77.8713 98.9568 77.8713C98.9568 77.8713 98.65 72.6894 95.4075 70.4559Z",
    fill: "url(#paint1_linear_245_633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.082 91.4171C137.303 88.5889 132.107 89.1853 132.107 89.1853C132.107 89.1853 131.419 94.3669 134.2 97.1934C136.979 100.022 142.173 99.4269 142.173 99.4269C142.173 99.4269 142.86 94.2453 140.082 91.4171Z",
    fill: "url(#paint2_linear_245_633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.024 66.0786C107.009 66.0786 108.618 64.5425 108.618 62.6477C108.618 60.7529 107.009 59.2168 105.024 59.2168C103.039 59.2168 101.43 60.7529 101.43 62.6477C101.43 64.5425 103.039 66.0786 105.024 66.0786Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.18 93.8893C157.165 93.8893 158.774 92.2802 158.774 90.2953C158.774 88.3103 157.165 86.7012 155.18 86.7012C153.195 86.7012 151.586 88.3103 151.586 90.2953C151.586 92.2802 153.195 93.8893 155.18 93.8893Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2518 134.016C92.0563 134.016 93.5192 135.552 93.5192 137.447C93.5192 139.342 92.0563 140.878 90.2518 140.878C88.4472 140.878 86.9844 139.342 86.9844 137.447C86.9844 135.552 88.4472 134.016 90.2518 134.016Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.355 73.9494C206.889 73.9494 208.133 75.1928 208.133 76.7267C208.133 78.2605 206.889 79.5039 205.355 79.5039C203.822 79.5039 202.578 78.2605 202.578 76.7267C202.578 75.1928 203.822 73.9494 205.355 73.9494Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.981 45.7036C109.899 45.7036 110.642 46.4472 110.642 47.3645C110.642 48.2818 109.899 49.0254 108.981 49.0254C108.064 49.0254 107.32 48.2818 107.32 47.3645C107.32 46.4472 108.064 45.7036 108.981 45.7036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45 35.9844C140.415 35.9844 141.197 36.7666 141.197 37.7315C141.197 38.6963 140.415 39.4785 139.45 39.4785C138.485 39.4785 137.703 38.6963 137.703 37.7315C137.703 36.7666 138.485 35.9844 139.45 35.9844Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.513 110.027C133.678 110.027 135.433 111.782 135.433 113.947C135.433 116.111 133.678 117.866 131.513 117.866C129.349 117.866 127.594 116.111 127.594 113.947C127.594 111.782 129.349 110.027 131.513 110.027Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.993 120.417C103.245 120.417 104.26 121.432 104.26 122.684C104.26 123.935 103.245 124.95 101.993 124.95C100.741 124.95 99.7266 123.935 99.7266 122.684C99.7266 121.432 100.741 120.417 101.993 120.417Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.681 144.499C111.407 144.499 111.995 145.088 111.995 145.813C111.995 146.539 111.407 147.127 110.681 147.127C109.955 147.127 109.367 146.539 109.367 145.813C109.367 145.088 109.955 144.499 110.681 144.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.771 76.7839C163.771 75.219 165.039 73.9505 166.604 73.9505C168.169 73.9505 169.438 75.219 169.438 76.7839C169.438 78.3487 168.169 79.6172 166.604 79.6172C165.039 79.6172 163.771 78.3487 163.771 76.7839Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.964 83.583C187.739 83.583 189.178 85.0219 189.178 86.7969C189.178 88.5719 187.739 90.0107 185.964 90.0107C184.189 90.0107 182.75 88.5719 182.75 86.7969C182.75 85.0219 184.189 83.583 185.964 83.583Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3458 59.2157C79.6759 59.2157 80.7542 60.067 80.7542 61.1171C80.7542 62.1672 79.6759 63.0186 78.3458 63.0186C77.0157 63.0186 75.9375 62.1672 75.9375 61.1171C75.9375 60.067 77.0157 59.2157 78.3458 59.2157Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6363 131.853C99.3806 130.899 99.9469 129.918 100.901 129.663C101.855 129.407 102.836 129.973 103.092 130.928C103.347 131.882 102.781 132.863 101.827 133.118C100.873 133.374 99.8919 132.808 99.6363 131.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.887 137.214H114.828C114.477 132.254 110.789 132.178 110.789 132.178C110.789 132.178 114.856 132.098 114.856 126.368C114.856 132.098 118.924 132.178 118.924 132.178C118.924 132.178 115.237 132.254 114.887 137.214ZM159.533 115.487H159.471C159.108 110.227 155.272 110.146 155.272 110.146C155.272 110.146 159.501 110.062 159.501 103.984C159.501 110.062 163.73 110.146 163.73 110.146C163.73 110.146 159.897 110.227 159.533 115.487Z",
    fill: "#E1E4E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_245_633",
    x: 0,
    y: 0,
    width: 255,
    height: 174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_245_633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_633",
    x1: 91.2891,
    y1: 120.608,
    x2: 74.8912,
    y2: 128.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_633",
    x1: 82.7759,
    y1: 63.1274,
    x2: 108.301,
    y2: 90.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_633",
    x1: 128.995,
    y1: 81.7566,
    x2: 149.084,
    y2: 113.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 170,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleasantlyUseful);
export default __webpack_public_path__ + "static/media/pleasantly-useful.aacbd9eebbac6b7451a1c2e3c792cd0a.svg";
export { ForwardRef as ReactComponent };